import { render, staticRenderFns } from "./AddCollCustomer.vue?vue&type=template&id=cadaa3c4&scoped=true"
import script from "./AddCollCustomer.vue?vue&type=script&lang=js"
export * from "./AddCollCustomer.vue?vue&type=script&lang=js"
import style0 from "./AddCollCustomer.vue?vue&type=style&index=0&id=cadaa3c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cadaa3c4",
  null
  
)

export default component.exports